export function getCoveringYears(reportYear) {
  return [reportYear - 2, reportYear - 1].join('-');
}

export function parseReportId(reportIdString) {
  return parseInt(reportIdString.slice(2), 10);
}
